module.exports = __webpack_public_path__ + "static/media/covid19-desktop-en.e4e05a2e.jpg";